export enum SERVICE_TYPE {
  SERVICES_PAYMENTS = "services_payments",
  CELLPHONE_MINUTES = "cellphone_minutes",
  ENTERTAINMENT = "entretainment",
  TICKET = "ticket",
  INSURANCE = "insurance",
  OTHER = "other",
};
